export default __webpack_public_path__ + "static/media/profile.09552a12.png";